import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=479acb2f&scoped=true"
import script from "./industry.vue?vue&type=script&lang=js"
export * from "./industry.vue?vue&type=script&lang=js"
import style0 from "./industry.vue?vue&type=style&index=0&id=479acb2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479acb2f",
  null
  
)

export default component.exports